import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./utils/axios";
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import SlideVerify from 'vue-monoplasty-slide-verify'
import './assets/font_51h40t11p92/iconfont.css'

Vue.use(SlideVerify)
Vue.use(ElementUI);
Vue.use(UmyUi);

Vue.config.productionTip = false
Vue.prototype.$praseStrEmpty = function(str) {
  if (typeof str === 'undefined' || str === null) {
      return "";
  }
  return str;
}
Vue.directive('no-right-click', {
  bind(el) {
    el.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });
  },
  unbind(el) {
    el.removeEventListener('contextmenu', (event) => {
      event.preventDefault();
    });
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
